import definition from './menu.service';

/**
 * MenuApi settings
 * @type {{name: string, definition: MenuApi}}
 */
export default {
    name: 'MenuApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/menu/index.js